import React from "react";
import { CustomButton } from "./forms/buttons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Dropdown, Tooltip } from "antd";
import CompanyDetailCard from "../components/company_detail_card";
import { PlusCircleOutlined } from "@ant-design/icons";
export const TopHeader = ({ userInfo, menu, imgSource }) => {
  const history = useHistory();
  let is_bank_user = userInfo?.is_bank_user;
  
  return (
    <div className="main-header-menu border_layout">
      <div className="header-container">
        <img
          style={{ cursor: "pointer", width: "100px" }}
          alt="logo"
          src="images/logo.svg"
          className="main-header-menu-item"
          onClick={() => {
            history.push("/");
          }}
        />

        <div className="main-header-menu-item">
          {!is_bank_user && (
            <span className="add-org-button">
              <CustomButton
                onClick={() => {
                  history.push({ pathname: `/new-company` });
                }}
                label="Add New Organization"
                // style={{ borderRadius: "4px", backgroundColor: "#E8FBEF" }}
              />
            </span>
          )}
          <Tooltip className="add-org-icon" title="Add New Organization">
            <PlusCircleOutlined
              style={{
                display: "none",
                color: "var(--primary)",
                fontSize: "32px",
              }}
              onClick={() => {
                history.push({ pathname: `/new-company` });
              }}
            />
          </Tooltip>
          <span style={{ width: "20px" }}></span>

          <Dropdown overlay={menu} trigger={["click"]}>
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              <img className="user-avatar-img" src={imgSource} alt="avatar" />
            </a>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};
